import "./Login.css";
import React, {useEffect, Fragment, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { loginSchema } from "./LoginValidation";
import {loginUser} from 'features/auth/authSlice'

import BrandingImage from "assets/images/Group 48.png";
import ExpressionPink from "assets/images/expression-pink4.png";
import ExpressionGreen from "assets/images/expression-green2.png";
import ApproveIcon from "assets/images/Approve.png";
import HidePassword from "assets/images/eye-password-hide.png";
import ShowPassword from "assets/images/eye-password-show.png";

import Swal from 'sweetalert2'
import Loader from "utilities/reusableComponent/Loader/Loader";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {loading, userToken: userToken} = useSelector((state) => state.auth)
  const [showPassword, setShowPassword] = useState(false);

  // Login form initial values
  const initialValues = {
    email: "",
    password: ""
  }

  // Handling on Submit register form
  const onHandleLogin = (values) => {
    const loginPayloads = {
      "email": values.email,
      "password": values.password,
      "role": "teacher"
    };

    dispatch(loginUser(loginPayloads)).then((result) => {
      if(result.payload !== undefined) {
        if(result.payload.status === 1) {
          // show error message when login is failed
          const swalFailedMessage = Swal.mixin({
            customClass: {
              popup: 'swal-failed-popup',
              confirmButton: "swal-success",
              title: 'swal-title',
            },
            buttonsStyling: false,
          });
          swalFailedMessage.fire({
            title: "Sorry!",
            html: `<p class='swal-text-html'>${result.payload.error_message}</p>`,
            imageWidth: 65,
            imageHeight: 60,
            confirmButtonText: "Ok",
          });
      
        } else {
          // if login success redirect to homepage
          navigate("/home");
        }
      }
    });
  }

  let handleOnClickForgotPassword = () => {
    navigate("/forgot-password");
  };

  let handleOnClickRegister = () => {
    navigate("/register");
  };

  // function to handling show or hide password
  const handlingShowPassword = () => {
    if(showPassword === true) {
      setShowPassword(false)
    } else {
      setShowPassword(true)
    }
  }

  useEffect(() => {
    // if user has login redirect to homepage
    if (userToken) {
      navigate("/home");
    }
  }, []);

  return (
    <Fragment>
      <div className="login mx-auto relative flex">
        <aside className="w-[473px] flex-shrink-0 max-h-screen bg-yellow sticky right-0 top-0 h-screen overflow-hidden">
          <img
            src={BrandingImage}
            alt=""
            className="w-[199px] mt-[277px] mx-auto"
          />
          <img
            src={ExpressionPink}
            alt=""
            className="absolute w-[112px] bottom-[-15px] left-[-13px] z-0"
          />
          <img
            src={ExpressionGreen}
            alt=""
            className="absolute w-[91px] bottom-[-45px] right-0 rotate-[-4.139deg] z-0"
          />
        </aside>
        <div className="w-full bg-white py-[100px] px-[50px]">
          <h3 className="text-4xl font-nunito font-bold text-center mb-[50px]">
            Welcome Back
          </h3>
          <p className="w-[453px] text-[22px] text-center mx-auto mb-[50px]">
            Enter your account details below to login to Flow Minder
          </p>
          <Formik
            initialValues= {initialValues}
            validationSchema= {loginSchema}
            onSubmit={(values) => onHandleLogin(values)}
          >
            {({errors, values}) => {
              return (
              <Form>
                <div className="w-[453px] mx-auto grid justify-items-center">
                  <div className="col-span-2 flex justify-end items-center relative">
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      className="rounded-[99px] w-[453px] h-[66px] box-border mb-[60px] pr-[55px] pl-8 py-[10px] bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color opacity-[0.99] placeholder:text-form-placeholder-color"
                    />
                    {!errors.email && values.email !== ""  && (
                      <img
                        src={ApproveIcon}
                        className="w-[36px] h-[36px] absolute mr-6 mt-[-58px] flex-shrink-0"
                        alt=""
                      />
                    )}
                  </div>
                  <div className="w-[453px] justify-start mt-[-55px]">
                    {errors.email && <small className="text-red-500">{errors.email}</small>}
                  </div>

                  <div className="col-span-2 flex justify-end items-center relative">
                    <div className="w-full">
                      <Field
                        type={showPassword === true ? 'text' : 'password'}
                        name="password"
                        className="rounded-[99px] w-[453px] h-[66px] box-border mb-[55px] pr-[60px] pl-8 py-[10px] bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color opacity-[0.99] placeholder:text-form-placeholder-color"
                        placeholder="Password"
                      />
                    </div>
                    <div className="w-[24px] h-[24px] absolute mr-6 mt-[-54px] flex-shrink-0 cursor-pointer" onClick={handlingShowPassword}>
                      <img
                        src= {showPassword === true ? HidePassword : ShowPassword}
                        width={24}
                        height="auto"
                      />
                    </div>  
                  </div>
                  <div className="w-[453px] justify-start mt-[-55px]">
                    {errors.password && <small className="text-red-500">{errors.password}</small>}
                  </div>
                  
                  <div 
                    className=" col-span-2 w-[453px] mb-[30px] text-black text-center cursor-pointer"
                    onClick={handleOnClickForgotPassword}
                  >
                    <span className="underline underline-offset-2 text-[22px] ">Forgotten Password?</span>
                  </div>
                  <div
                    className=" col-span-2 w-[451px] h-[76px] rounded-[99px] py-[26px] mb-[55px] leading-[21px] bg-custom-navy text-white text-base font-bold text-center cursor-pointer"
                  >
                    <button type="submit" className="w-[451px]">Login</button>
                  </div>
                  <div className="col-span-2 mb-[30px] ">
                    <h3 className="text-2xl text-black font-bold text-center">
                      Not yet signed up?
                    </h3>
                  </div>
                  <div 
                    className="col-span-2 w-[451px] h-[76px] rounded-[99px] py-[26px] leading-[21px] text-black border-[0.682px] border-custom-gray text-base font-extrabold text-center cursor-pointer"
                    onClick={handleOnClickRegister}
                  >
                    Register
                  </div>
                </div>
              </Form>
            )}}
            </Formik>
        </div>
      </div>
      {loading && < Loader/>}
    </Fragment>
  );
}

export default Login;
